export { autoTextSize, updateTextSize } from "./auto-text-size-standalone.js";
export { AutoTextSize } from "./auto-text-size-react.js";
